var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-2 mt-md-3 mt-xl-4" },
    _vm._l(_vm.contractualDocuments, function (contract) {
      return _c("div", { key: contract.label }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("ob1-liens", {
                attrs: {
                  href: contract.link + "?webview_action=pdf",
                  target: _vm.webView ? "_self" : "_blank",
                  text: contract.label,
                  "with-arrow": true,
                },
              }),
            ],
            1
          ),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }